(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curate-hair-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uc-hair-curation')) {
    customElements.define(
      'uc-hair-curation',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return
          this.dataset.initialized = 'true'
          this.tabs = Array.from(this.querySelectorAll('[data-tab-id]'))
          this.panels = Array.from(this.querySelectorAll('[data-panel-id]'))
          this.tabsRail = this.querySelector('[data-tabs]')
          this.handleClick = (event) => {
            const tab = event.target.closest('[data-tab-id]')
            if (tab && this.contains(tab)) {
              this.activate(tab.dataset.tabId)
              return
            }
            const panel = event.target.closest('[data-panel-id]')
            const track = panel?.querySelector('[data-product-track]')
            if (!track) {
              if (event.target.closest('[data-tabs-prev]')) this.tabsRail?.scrollBy({ left: -320, behavior: 'smooth' })
              if (event.target.closest('[data-tabs-next]')) this.tabsRail?.scrollBy({ left: 320, behavior: 'smooth' })
              return
            }
            if (event.target.closest('[data-products-prev]')) track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' })
            if (event.target.closest('[data-products-next]')) track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' })
          }
          this.handleKeydown = (event) => {
            const currentIndex = this.tabs.indexOf(event.target)
            if (currentIndex < 0) return
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
            event.preventDefault()
            const direction = event.key === 'ArrowRight' ? 1 : -1
            const nextTab = this.tabs[(currentIndex + direction + this.tabs.length) % this.tabs.length]
            nextTab.focus()
            this.activate(nextTab.dataset.tabId)
          }
          this.handleBlockSelect = (event) => {
            const panel = event.target.closest?.('[data-panel-id]')
            if (panel && this.contains(panel)) this.activate(panel.dataset.panelId)
          }
          this.addEventListener('click', this.handleClick)
          this.addEventListener('keydown', this.handleKeydown)
          document.addEventListener('shopify:block:select', this.handleBlockSelect)
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick)
          this.removeEventListener('keydown', this.handleKeydown)
          document.removeEventListener('shopify:block:select', this.handleBlockSelect)
        }

        activate(id) {
          this.tabs.forEach((tab) => {
            const active = tab.dataset.tabId === id
            tab.classList.toggle('is-active', active)
            tab.setAttribute('aria-selected', active ? 'true' : 'false')
            tab.tabIndex = active ? 0 : -1
          })
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.panelId !== id
          })
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-series-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uc-series-products')) {
    customElements.define(
      'uc-series-products',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return
          this.dataset.initialized = 'true'
          this.select = this.querySelector('[data-series-select]')
          this.panels = Array.from(this.querySelectorAll('[data-series-panel]'))
          this.onChange = (event) => {
            if (event.target === this.select) this.activate(event.target.value)
          }
          this.onClick = (event) => {
            const button = event.target.closest('[data-series-prev], [data-series-next]')
            if (!button || !this.contains(button)) return
            const panel = button.closest('[data-series-panel]')
            const viewport = panel?.querySelector('[data-series-viewport]')
            if (!viewport) return
            const direction = button.hasAttribute('data-series-prev') ? -1 : 1
            viewport.scrollBy({ left: viewport.clientWidth * 0.9 * direction, behavior: 'smooth' })
          }
          this.onBlockSelect = (event) => {
            const panel = event.target.closest?.('[data-series-panel]')
            if (panel && this.contains(panel)) this.activate(panel.dataset.seriesPanel)
          }
          this.addEventListener('change', this.onChange)
          this.addEventListener('click', this.onClick)
          document.addEventListener('shopify:block:select', this.onBlockSelect)
          if (this.select?.value) this.activate(this.select.value)
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange)
          this.removeEventListener('click', this.onClick)
          document.removeEventListener('shopify:block:select', this.onBlockSelect)
        }

        activate(id) {
          if (!id) return
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.seriesPanel !== id
          })
          if (this.select && this.select.value !== id) this.select.value = id
          const activePanel = this.querySelector('[data-series-panel]:not([hidden])')
          if (activePanel) {
            this.select?.setAttribute('aria-controls', activePanel.id)
            activePanel.querySelector('[data-series-viewport]')?.scrollTo({ left: 0 })
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
